var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumPrimaryHouse = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/house") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/house"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(5.000000, 6.000000)",
    fill: "#1B7690",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.221067,16.8328125 L21.333567,0.5315625 C20.557317,-0.1771875 19.376067,-0.1771875 18.566067,0.5315625 L0.67856697,16.8328125 C0.0373169696,17.4065625 -0.16518303,18.2840625 0.13856697,19.0940625 C0.44231697,19.9040625 1.18481697,20.4103125 2.02856697,20.4103125 L4.89731697,20.4103125 L4.89731697,36.7453125 C4.89731697,37.3865625 5.43731697,37.9265625 6.07856697,37.9265625 L15.899817,37.9265625 C16.541067,37.9265625 17.081067,37.3865625 17.081067,36.7453125 L17.081067,26.8228125 L22.852317,26.8228125 L22.852317,36.7453125 C22.852317,37.3865625 23.392317,37.9265625 24.033567,37.9265625 L33.854817,37.9265625 C34.496067,37.9265625 35.036067,37.3865625 35.036067,36.7453125 L35.036067,20.4103125 L37.904817,20.4103125 C38.748567,20.4103125 39.491067,19.9040625 39.794817,19.0940625 C40.064817,18.2840625 39.828567,17.4065625 39.221067,16.8328125 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.664817,2.3540625 L26.801067,2.3540625 L35.846067,10.5890625 L35.846067,3.5353125 C35.846067,2.8603125 35.306067,2.3540625 34.664817,2.3540625 Z",
    id: "Path"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumPrimaryHouse);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-primary-house.6d182489693303e6631c2c824f50e4f8.svg";